module.exports = __webpack_public_path__ + "assets/img/dinge.f0498d2f.svg";